import { BadgeCheck } from "lucide-react";

// Premium trust badge — rendered ONLY from server-computed verification state
// (auth/me id_verified, spot.host_id_verified, booking counterpart flags).
// The client can never manufacture it: no prop, no badge.
export default function VerifiedBadge({ verified, testId = "id-verified-badge", className = "" }) {
  if (!verified) return null;
  return (
    <span data-testid={testId}
          className={`inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider text-emerald-400 bg-emerald-500/10 border border-emerald-500/25 rounded-full px-2 py-0.5 ${className}`}>
      <BadgeCheck className="w-3 h-3" /> ID Verified
    </span>
  );
}
